// extracted by mini-css-extract-plugin
export default {"container":"jZ-z","heading":"kZ-z","links":"lZ-z","copy":"mZ-z","subCopy":"nZ-z","linksLeft":"oZ-z","linksCenter":"pZ-z","linksRight":"qZ-z","link":"rZ-z","onlyLink":"sZ-z"};